(() => {
  if (window.wolffHomeHeaderInstalled) return;
  window.wolffHomeHeaderInstalled = true;
  let cleanup = () => {};
  const setup = () => {
    cleanup();
    const header = document.querySelector('.wolff-header[data-home-overlay]');
    const section = header?.closest('.shopify-section');
    if (!section) return;
    // Shopify pixels and apps can inject non-section elements between header and hero.
    // Locate the first theme section rather than relying on immediate sibling order.
    let first = section.nextElementSibling;
    while (first && !first.matches('.shopify-section, main')) first = first.nextElementSibling;
    if (first?.tagName === 'MAIN') first = first.querySelector('.shopify-section');
    const hero = first?.querySelector('wolff-slideshow.wolff-hero');
    if (!hero) return;
    const announcement = document.getElementById('shopify-section-announcement-bar');
    const events = new AbortController();
    let frame;
    let hovered = false;
    const desktopHover = matchMedia('(hover: hover) and (pointer: fine)');
    document.body.classList.add('wolff-home-overlay');
    section.classList.add('wolff-home-header-section');
    header.setAttribute('data-home-overlay-active', '');
    hero.setAttribute('data-home-hero', '');
    const update = () => {
      frame = null;
      const announcementBox = announcement?.getBoundingClientRect();
      document.body.style.setProperty('--wolff-header-top', `${Math.max(0, announcementBox?.bottom || 0)}px`);
      header.classList.toggle('is-home-transparent', window.scrollY <= 32 && !hovered && !header.querySelector('details[open]'));
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const resize = new ResizeObserver(() => {
      document.body.style.setProperty('--wolff-header-height', `${section.getBoundingClientRect().height}px`);
      document.body.style.setProperty('--wolff-announcement-height', `${announcement?.getBoundingClientRect().height || 0}px`);
      schedule();
    });
    resize.observe(section);
    if (announcement) resize.observe(announcement);
    const observer = new MutationObserver(schedule);
    observer.observe(header, {attributes: true, subtree: true, attributeFilter: ['open']});
    header.addEventListener('toggle', event => {
      // Keep the native drawer overlay in sync when it closes via Escape.
      if (event.target.matches('header-drawer > details')) {
        event.target.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(event.target.open));
      }
      schedule();
    }, {capture: true, signal: events.signal});
    header.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse' && desktopHover.matches) { hovered = true; schedule(); }
    }, {signal: events.signal});
    header.addEventListener('pointerleave', () => { hovered = false; schedule(); }, {signal: events.signal});
    desktopHover.addEventListener('change', () => { hovered = false; schedule(); }, {signal: events.signal});
    window.addEventListener('scroll', schedule, {passive: true, signal: events.signal});
    window.addEventListener('pageshow', schedule, {signal: events.signal});
    update();
    cleanup = () => {
      events.abort();
      resize.disconnect();
      observer.disconnect();
      cancelAnimationFrame(frame);
      document.body.classList.remove('wolff-home-overlay');
      section.classList.remove('wolff-home-header-section');
      header.classList.remove('is-home-transparent');
      header.removeAttribute('data-home-overlay-active');
      hero.removeAttribute('data-home-hero');
      ['--wolff-header-top', '--wolff-header-height', '--wolff-announcement-height'].forEach(name => document.body.style.removeProperty(name));
      cleanup = () => {};
    };
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:reorder', setup);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches('.wolff-home-header-section') || event.target.querySelector('[data-home-hero]')) cleanup();
  });
})();
